import { dateI18n } from '@wordpress/date';
import { Fragment, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Scheduler } from './dates/scheduler';
import { useEntityProp } from '@wordpress/core-data';

import {
	DateTimePicker,
	Button,
	Flex,
	FlexItem,
	RadioControl,
	Dropdown,
} from '@wordpress/components';

export function Dates( props ) {
	const { onChangeDate, rules, activeTab, postId } = props;

	/*const [ meta, setMeta ] = useEntityProp(
		'postType',
		'popper',
		'meta',
		postId
	);

	useEffect( () => {
		if ( Array.isArray( rules[ activeTab ] ) ) {
			console.log( 'is array' );
			const converted = { ...rules[ activeTab ][ 0 ] };
			setMeta( {
				...meta,
				popper_rules: { ...meta.popper_rules, date: converted },
			} );
		}
	}, [] );*/

	const rule = Array.isArray( rules[ activeTab ] )
		? rules[ activeTab ][ 0 ]
		: rules[ activeTab ];

	console.log( rule );

	const onChangeTemp = ( key, val ) => {
		const update = { ...rules[ activeTab ], [ key ]: val };
		onChangeDate( update );
	};

	return (
		<Fragment>
			<Flex
				align="start"
				justify="start"
				style={ { marginBottom: '1em' } }
			>
				<FlexItem>
					<RadioControl
						label={ __(
							'Choose when you want display this popup.'
						) }
						selected={ rule.type }
						options={ [
							{
								label: __( 'Evergreen', 'popper' ),
								value: 'evergreen',
							},
							{
								label: __( 'Custom dates', 'popper' ),
								value: 'custom',
							},
						] }
						onChange={ ( val ) => onChangeTemp( 'type', val ) }
					/>
				</FlexItem>
			</Flex>
			{ 'custom' === rule.type && (
				<Fragment>
					<Flex
						align="start"
						justify="start"
						className="popper-modal-row"
					>
						<FlexItem>
							<b>From:</b>
						</FlexItem>
						<FlexItem>
							<Dropdown
								popoverProps={ { placement: 'bottom-start' } }
								renderToggle={ ( { isOpen, onToggle } ) => (
									<Button
										variant="secondary"
										onClick={ onToggle }
										aria-expanded={ isOpen }
									>
										{ rule.startDate
											? dateI18n(
													'F j, Y g:i a',
													rule.startDate
											  )
											: __(
													'Click here to set start date.',
													'popper'
											  ) }
									</Button>
								) }
								renderContent={ () => (
									<DateTimePicker
										__nextRemoveHelpButton
										label="My Date/Time Picker"
										currentDate={ rule.startDate }
										onChange={ ( val ) =>
											onChangeTemp( 'startDate', val )
										}
										is12Hour={ true }
										isInvalidDate={ ( val ) => {
											if ( rule.endDate ) {
												return (
													new Date( val ) >
													new Date( rule.endDate )
												);
											}
										} }
									/>
								) }
							/>
						</FlexItem>
						<FlexItem>
							<b>To:</b>
						</FlexItem>
						<FlexItem>
							<Dropdown
								popoverProps={ { placement: 'bottom-start' } }
								renderToggle={ ( { isOpen, onToggle } ) => (
									<Button
										variant="secondary"
										onClick={ onToggle }
										aria-expanded={ isOpen }
									>
										{ rule.endDate
											? dateI18n(
													'F j, Y g:i a',
													rule.endDate
											  )
											: __(
													'Click here to set start date.',
													'popper'
											  ) }
									</Button>
								) }
								renderContent={ () => (
									<DateTimePicker
										__nextRemoveHelpButton
										label="My Date/Time Picker"
										currentDate={ rule.endDate }
										onChange={ ( val ) =>
											onChangeTemp( 'endDate', val )
										}
										is12Hour={ true }
										isInvalidDate={ ( val ) =>
											new Date( val ) <
											new Date( rule.startDate )
										}
									/>
								) }
							/>
						</FlexItem>
					</Flex>
				</Fragment>
			) }
			<hr />
			<Scheduler
				rule={ rule }
				onChange={ onChangeTemp }
				postId={ postId }
			/>
		</Fragment>
	);
}
